import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  ISchoolTransportationCreateParams,
  ISchoolTransportationFilterParams,
  ISchoolTransportationProps,
  ISchoolTransportationSimpleProps,
  ISchoolTransportationUpdateParams,
} from './types';

const ENDPOINT = 'v1/schoolTransportation';

const formatApiError = (error: any): Error => {
  return new Error(
    error?.response?.data?.message || 'Ocorreu um erro inesperado. Tente novamente.'
  );
};

export const createSchoolTransportationAsync = async ({
  data,
}: ISchoolTransportationCreateParams): Promise<ISchoolTransportationProps> => {
  try {
    const response = await api.post(ENDPOINT, data);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getSchoolTransportationByIdAsync = async (
  id: number,
): Promise<ISchoolTransportationProps> => {
  try {
    const response = await api.get(`${ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getAllSchoolTransportationByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ISchoolTransportationFilterParams
): Promise<ISchoolTransportationSimpleProps[]
> => {
  try {
    const response = await api.get(`${ENDPOINT}/getAllByLicense`, {
      params: {
        ...pagination,
        name: filter?.name, 
      },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getAllSchoolTransportationCountAsync = async (filter: ISchoolTransportationFilterParams): Promise<number> => {
  try {
    const response = await api.get(`${ENDPOINT}/getAllByLicense/count`, {
      params: {
        name: filter?.name,
      },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error); 
  }
};

export const updateSchoolTransportationAsync = async ({
  id,
  data,
}: ISchoolTransportationUpdateParams): Promise<ISchoolTransportationProps> => {
  try {
    const response = await api.put(`${ENDPOINT}/${id}`, data);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const deleteSchoolTransportationAsync = async (
  id: number,
): Promise<void> => {
  try {
    const response = await api.delete(`${ENDPOINT}/${id}`);
  } catch (error) {
    throw formatApiError(error);
  }
};
